import { FETCH_PRODUCT_PRODUCT_TYPE_PENDING, FETCH_PRODUCT_PRODUCT_TYPE_SUCCESS, FETCH_PRODUCT_PRODUCT_TYPE_ERROR } from '../action/productProductTypeAction';

const initialState = {
    
    pending: false,
    productType:[],
    error: null
}

const productProductTypeReducer = (state = initialState, action) => {
   
    switch (action.type) {
        case FETCH_PRODUCT_PRODUCT_TYPE_PENDING:
            return {
                ...state,
                pending: true
            }
        case FETCH_PRODUCT_PRODUCT_TYPE_SUCCESS:
            return {
                ...state,
                pending: false,
                productType:action.payload,
            }
        case FETCH_PRODUCT_PRODUCT_TYPE_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error
            }
        default:
            return state;
    }
}
export default productProductTypeReducer;
export const getproductProductTypePending = state => state.pending;
export const getproductProductTypeError = state => state.error;
export const getProductType = state => state.productType;

